/* ==========================================================================
   LAUZON — the three-section switch and panels: Hall of Fame count.
   Markup: snippets/lauzon-section-links.liquid. Endpoint:
   sections/lauzon-hof-count.liquid (Section Rendering API on the archive,
   filtered to one vendor).

   Every [data-lzsl-hof] block names the URL to ask. One request per URL,
   shared by the switch and the panels. The Hall of Fame button and panel are
   rendered hidden and are only ever revealed, when the brand has at least one
   piece; on a failed request nothing changes.
   ========================================================================== */
(function () {
  var roots = document.querySelectorAll('[data-lzsl-hof]');
  if (!roots.length) return;
  var cache = {};

  function ask(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-hof-count]');
          if (!el) return { n: 0, img: '' };
          return {
            n: parseInt(el.getAttribute('data-hof-count'), 10) || 0,
            img: el.getAttribute('data-hof-img') || ''
          };
        })
        .catch(function () { return { n: 0, img: '' }; });
    }
    return cache[url];
  }

  Array.prototype.forEach.call(roots, function (root) {
    ask(root.getAttribute('data-lzsl-hof')).then(function (res) {
      if (res.n < 1) return;
      root.querySelectorAll('[data-lzsl-hof-n]').forEach(function (el) {
        el.textContent = res.n;
      });
      root.querySelectorAll('[data-lzsl-hof-img]').forEach(function (img) {
        if (res.img) img.src = res.img;
        else img.remove();
      });
      root.querySelectorAll('[data-lzsl-hof-item]').forEach(function (el) {
        el.hidden = false;
      });
      root.hidden = false;
    });
  });
})();
